import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { CheckCircle2 } from "lucide-react";
import api from "../lib/api";

// PayPal-supported currencies; others fall back to USD for the PayPal button.
const PP_SUPPORTED = new Set(["AUD","BRL","CAD","CNY","CZK","DKK","EUR","HKD","HUF","ILS","JPY","MYR","MXN","TWD","NZD","NOK","PHP","PLN","GBP","SGD","SEK","CHF","THB","USD"]);

const PayPalCheckout = ({ packageId, currency = "USD", email, name, onSuccess }) => {
  const [config, setConfig] = useState(null);
  const [show, setShow] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (show && !config) {
      api.get("/paypal/config").then((r) => setConfig(r.data)).catch(() => setErr("PayPal is unavailable right now."));
    }
  }, [show, config]);

  const code = (currency || "USD").toUpperCase();
  const ppCurrency = PP_SUPPORTED.has(code) ? code : "USD";

  if (done) {
    return (
      <div className="pp-done" data-testid="paypal-done"><CheckCircle2 size={18} color="#3fae4a" /> Payment complete via PayPal!</div>
    );
  }

  if (!show) {
    return (
      <button type="button" className="btn pp-toggle" onClick={() => setShow(true)} data-testid="paypal-toggle">
        Pay with PayPal
      </button>
    );
  }

  if (err) return <p className="pp-err">{err}</p>;
  if (!config) return <p className="pp-loading">Loading PayPal…</p>;

  return (
    <div className="pp-wrap" data-testid="paypal-buttons">
      {ppCurrency !== code && <p className="pp-note">PayPal doesn't support {code}; you'll be charged in USD.</p>}
      <PayPalScriptProvider options={{ "client-id": config.client_id, currency: ppCurrency, intent: "capture", components: "buttons" }} key={ppCurrency}>
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill", label: "paypal", height: 44 }}
          createOrder={async () => {
            const r = await api.post("/paypal/create-order", { package_id: packageId, currency: ppCurrency.toLowerCase(), email, name });
            return r.data.order_id;
          }}
          onApprove={async (data) => {
            const r = await api.post("/paypal/capture-order", { order_id: data.orderID });
            if (r.data.payment_status === "paid") { setDone(true); onSuccess && setTimeout(onSuccess, 1200); }
            else setErr("Payment could not be completed.");
          }}
          onError={() => setErr("PayPal could not complete the payment. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default PayPalCheckout;
